import React from 'react'
import Grid from '@material-ui/core/Grid'
import classNames from 'classnames'
import Button from '@material-ui/core/Button'
import { ProductParameterExpansionProps } from './root-props'
import { ProductParameterValue } from '../../../../product/model'
import { ProductParameterExpansionDesignOwn } from './design-own'
import { ProductParameterExpansionDesignLibrary } from './design-library'
import { ProductParameterExpansionDesignLater } from './design-later'

export const ProductParameterExpansionDesign = (props: ProductParameterExpansionProps<ProductParameterValue>) => {
    const [view, setView] = React.useState('options')
    const onValueClick = (value: ProductParameterValue) => {
        if (value.key === 'own' || value.key === 'library' || value.key === 'project' || value.key === 'later' ) {
            setView(value.key)
            props.valueSelect([value], true)
        } else {
            props.valueSelect([value], false)
        }
    }
    return <Grid container justify='space-around' className='ExpansionDesignContainer'>
        {view === 'options' && props.values.map((value, key) => <Grid
            item xs={6}
            key={key}
            container
            direction='column'
            alignItems='center'
            className={classNames({ 'DesignItem': true, 'DesignItem-selected': props.valueSelected && props.valueSelected.some(it => it.key === value.key) })}
        >
            <Button disabled={!!value.valueProvider && !value.valueProvider.list.filter(it => !it.disabled).length} onClick={() => onValueClick(value)}>{value.label}</Button>
        </Grid>)}
        {view === 'own' && <ProductParameterExpansionDesignOwn
            back={() => { props.valueSelect([], true); setView('options'); }}
            value={props.values.find(it => it.key === 'own')}
            manual={props.parameter.manual}
            valueSelect={(value: ProductParameterValue) => { setView('options'); props.valueSelect([value], false); }}
            valueSelected={props.valueSelected}
            twoSided={false} /> // Todo: get the value from product options
        }
        {view === 'project' && <ProductParameterExpansionDesignOwn
            back={() => { props.valueSelect([], true); setView('options'); }}
            value={props.values.find(it => it.key === 'project')}
            manual={props.parameter.manual}
            valueSelect={(value: ProductParameterValue) => { setView('options'); props.valueSelect([value], false); }}
            valueSelected={props.valueSelected}
            twoSided={false}
            description={true} /> // Todo: get the value from product options
        }
        {view === 'library' && <ProductParameterExpansionDesignLibrary
            close={() => { props.valueSelect([], true); setView('options'); }}
            value={props.values.find(it => it.key === 'library')}
            valueSelect={(value: ProductParameterValue) => { setView('options'); props.valueSelect([value], false); }} />
        }
        {view === 'later' && <ProductParameterExpansionDesignLater
            back={() => { props.valueSelect([], true); setView('options'); }}
            value={props.values.find(it => it.key === 'later')}
            manual={props.parameter.manual}
            valueSelect={(value: ProductParameterValue) => { setView('options'); props.valueSelect([value], false); }}
            valueSelected={props.valueSelected}
            twoSided={false} /> // Todo: get the value from product options
        }
    </Grid>
}
